import type {
  ICallSheetVenue,
  IExpandedCallSheetData,
} from "../../../../types/callsheet";


export const getCallSheetDisplayName = (
  callSheetData?: IExpandedCallSheetData | null,
): string => {
  const deceased = callSheetData?.booking?.deceased?.[0];
  const deceasedName = [deceased?.first_name, deceased?.surname]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (deceasedName) return deceasedName;

  return (callSheetData?.title || "").replace(/^Stream for\s*/i, "").trim();
};

const isPlaceholder = (value?: string | null) =>
  !value || !value.trim() || value.trim().toUpperCase() === "N/A";

const joinLocation = (parts: Array<string | null | undefined>) => {
  const kept: string[] = [];
  for (const part of parts) {
    if (isPlaceholder(part)) continue;
    const value = part!.trim();
    if (kept.some((k) => k.toLowerCase().includes(value.toLowerCase()))) continue;
    kept.push(value);
  }
  return kept.join(", ");
};

const venueLocation = (venue?: ICallSheetVenue | null) =>
  joinLocation([
    venue?.name,
    venue?.address_one,
    venue?.address_two,
    venue?.suburb,
    venue?.city,
  ]);


export const getCallSheetLocation = (
  callSheetData?: IExpandedCallSheetData | null,
): string => {
  const booking = callSheetData?.booking;
  const bookingType = (booking?.booking_type || "").toLowerCase();
  const service = (booking?.service || "").toLowerCase();
  const isConferenceOrChurch =
    ["conference", "church"].includes(bookingType) ||
    ["conference", "church"].includes(service);

  if (!isConferenceOrChurch) {
    return venueLocation(booking?.services?.[0]?.venue);
  }

  const venueName = isPlaceholder(callSheetData?.venue_name)
    ? null
    : callSheetData?.venue_parent?.name
      ? `${callSheetData.venue_parent.name} — ${callSheetData.venue_name}`
      : callSheetData?.venue_name;

  const streamLocation = joinLocation([
    venueName,
    callSheetData?.address_one,
    callSheetData?.address_two,
    callSheetData?.suburb,
    callSheetData?.city,
  ]);

  return streamLocation || venueLocation(callSheetData?.event_details?.venue);
};
